import client from "@/lib/api";

const IMG_EXT = /\.(jpe?g|png|webp)$/i;
const MAX_SIDE = 1920;
export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp";

export const isImageFile = (f) => !!f && ((f.type && /^image\/(jpeg|png|webp)$/.test(f.type)) || IMG_EXT.test(f.name || "") || (!f.type && f.size > 0));

// Resize/re-encode large photos (camera shots are often 5–15 MB) so they fit the 8 MB limit.
export async function prepareImage(file) {
  if (file.size < 1.5 * 1024 * 1024 && /^image\/(jpeg|png|webp)$/.test(file.type)) return file;
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bmp.width * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.85));
    if (!blob) return file;
    return new File([blob], (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}

export async function uploadImageFile(file, onProgress) {
  const ready = await prepareImage(file);
  if (ready.size > 8 * 1024 * 1024) throw new Error("Image too large (max 8 MB).");
  const fd = new FormData();
  fd.append("file", ready);
  const r = await client.post("/uploads/image", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
    onUploadProgress: (e) => e.total && onProgress?.(Math.round((e.loaded * 100) / e.total)),
  });
  return r.data;
}

export const uploadErrorText = (e) =>
  e?.response?.data?.detail || (e?.code === "ECONNABORTED" || !e?.response ? "Network problem — check connection and retry." : e?.message) || "Upload failed.";
